import { library } from "@fortawesome/fontawesome-svg-core";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import Modal from "react-modal";
import { isEmptyString } from "../classes/StringHelper";

library.add(faTimes);

export default (props: {
    children: any,
    className?: string,
    isClosable?: boolean,
    isOpen: boolean,
    onRequestClose?: () => void,
    shouldCloseOnEsc?: boolean,
}) => {
    return props.isOpen ? <Modal
        ariaHideApp={false}
        className={"ReactModal__Content ReactModal__Content--after-open ReactModal__Content " + (!isEmptyString(props.className) ? props.className : "")}
        isOpen={props.isOpen}
        overlayClassName={"ReactModal__Overlay ReactModal__Overlay--after-open ReactModal__Overlay CMS_PF_dialog CMS_PF_react CMS_react_ScrollingDialog"}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={props.isClosable !== false && props.shouldCloseOnEsc === true}
        onRequestClose={() => props.onRequestClose && props.onRequestClose()}
    >
        {props.isClosable !== false ? <a
            className="CMS_dialogClose CMS_button CMS_bSquare CMS_bCancel"
            href="#"
            onClick={(e) => {
                e.preventDefault();
                if (props.onRequestClose) {
                    props.onRequestClose();
                }
            }}
        >
            <FontAwesomeIcon icon="times" />
            <span className="offScreen">Close</span>
        </a> : null}
        {props.children}
    </Modal> : null;
};
